import React from 'react'
import styled from 'styled-components'
import {
  CopyrightUserType,
  FollowStatus,
  getAiFansCountRank_copyrightStatisticsModule_rankList_edges_node_base_memberDetail,
} from '~/graphqls/types'
import { MyImage } from '~/components/ui/MyImage'
import Link from 'next/link'
import FollowBtn from './FollowBtn'
import { MyAvatar } from '../ui/MyAvatar'

const StyledSingleCreator = styled.div`
  border: 1px solid ${props => props.theme['neutral-300']};
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 32px;
  background: ${props => props.theme['neutral-100']};
  .creator-bg {
    border-radius: 8px;
    height: 112px;
  }
  .creator-avatar-wrap {
    position: relative;
    margin: -34px auto 16px;
    text-align: center;
    height: 64px;
    width: 64px;
  }
  .creator-avatar {
    height: 100%;
    width: 100%;
    border-radius: 50%;
    border: 2px solid ${props => props.theme['neutral-300']};
  }

  .creator-name {
    text-align: center;
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
    color: ${props => props.theme['neutral-800']};
  }
  .creator-desc {
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    height: 40px;
    color: ${props => props.theme['neutral-400']};
    text-align: center;
  }
`

interface User {
  base?: {
    uid?: number
  } | null
  userRoleInfo: {
    artist: boolean | null
    aiArtist: boolean | null
  } | null
  backgroundUrl?: string | null
  avatarUrl?: string | null
  userType?: CopyrightUserType | null
  nickname?: string | null
  personalizedSignature?: string | null
  social?: {
    followStatus?: FollowStatus | null
  } | null
  memberDetail: getAiFansCountRank_copyrightStatisticsModule_rankList_edges_node_base_memberDetail | null
}

export const UserCard: React.FC<{
  data: User
  style?: React.CSSProperties
}> = ({ data, style }) => {
  return (
    <StyledSingleCreator style={style}>
      <Link href={`/user/${data.base?.uid}`}>
        <div>
          <MyImage
            tag="v1200"
            className="creator-bg"
            src={data.backgroundUrl}
            dark
          />
          <div className="creator-avatar-wrap">
            <MyAvatar
              className="creator-avatar"
              image={data?.avatarUrl as string}
              isVip={data?.memberDetail?.hold}
              iconClassName="!h-[24px] !w-[24px]"
              size={64}
            ></MyAvatar>
          </div>
          <div className="creator-name flex items-center justify-center">
            <span className="text-overflow">{data?.nickname}</span>
          </div>
          <div className="text-center my-2">
            <FollowBtn
              dark
              targetId={data.base?.uid}
              status={data.social?.followStatus}
            />
          </div>
          <div className="creator-desc line-clamp-2">
            {data?.personalizedSignature || '这个人很懒，什么都没有留下'}
          </div>
        </div>
      </Link>
    </StyledSingleCreator>
  )
}
